var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"search-link",attrs:{"href":"#","data-toggle":"search"}},[_c('i',{staticClass:"pg-search"}),_vm._v("Ecrivez n'importe où pour "),_c('span',{staticClass:"bold"},[_vm._v("rechercher")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-350827ac","hasScoped":false,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Header/SearchBar.vue
// module id = 1811
// module chunks = 0